import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { clearUser } from "../features/auth/authSlice";
import { persistor } from "../store";
import { useState } from "react";

const DashboardHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const user = useSelector((state) => state.auth.user);

  // Function to determine the title based on the current path
  // Function to determine the title based on the current path
  const getPageTitle = () => {
    if (location.pathname.includes("/dashboard")) return "Dashboard";
    if (location.pathname.includes("/sales")) return "Sales";
    if (location.pathname.includes("/overview")) return "Overview";
    if (location.pathname.includes("/allusers")) return "All Users";
    if (location.pathname.includes("/adduser")) return "Add User";
    if (location.pathname.includes("/setting")) return "Profile Setting";
    if (location.pathname.includes("/invoice")) return "Invoice";
    if (location.pathname.includes("/allProduct")) return "All Products";
    if (location.pathname.includes("/addProduct")) return "New Addition";
    if (location.pathname.includes("/edit-products")) return "Edit Products";
    if (location.pathname.includes("/all-products")) return "All Products";
    if (location.pathname.includes("/order-detail")) return "Order Detail";
    if (location.pathname.includes("/addUtilities")) return "Utitlities";

    return "Dashboard";
  };

  const handleLogout = () => {
    localStorage.clear();
    dispatch(clearUser());
    navigate("/login", { replace: true });
  };

  const togglePopup = () => {
    setIsPopupVisible((prev) => !prev);
  };

  const closePopup = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsPopupVisible(false);
    }
  };

  const handleProfileClick = () => {
    navigate("/admin/overview", { replace: true });
  };

  const handleChangePasswordClick = () => {
    navigate("/admin/reset-password", { replace: true });
  };

  return (
    <div>
      <div className="dashboard_hedaer">
        <div className="dashboard_inner">
          <h2 style={{ width: "25%" }}>{getPageTitle()}</h2>
          <div style={{ width: "45%" }} className="dashboard_serch_box">
            <input type="text" placeholder="Search here..." required />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M10.6468 11.3542C9.66083 12.1795 8.39083 12.6775 7.00616 12.6775C3.87483 12.6775 1.3335 10.1362 1.3335 7.0055C1.3335 3.87483 3.87483 1.3335 7.00616 1.3335C10.1362 1.3335 12.6782 3.87483 12.6782 7.0055C12.6782 8.39083 12.1802 9.6615 11.3548 10.6462L14.5208 13.8128C14.6182 13.9102 14.6668 14.0382 14.6668 14.1668C14.6668 14.5582 14.3088 14.6668 14.1668 14.6668C14.0388 14.6668 13.9108 14.6182 13.8128 14.5202L10.6468 11.3542ZM7.00616 2.33416C4.4275 2.33416 2.33483 4.4275 2.33483 7.0055C2.33483 9.5835 4.4275 11.6768 7.00616 11.6768C9.5835 11.6768 11.6775 9.5835 11.6775 7.0055C11.6775 4.4275 9.5835 2.33416 7.00616 2.33416V2.33416Z"
                fill="#6F757E"
              />
            </svg>
          </div>

          <div className="admin_profile_wepper">
            <img
              style={{ width: "40px", height: "40px" }}
              src={
                user?.gender === "male"
                  ? "/images/man.png"
                  : "/images/woman.png"
              }
              alt=""
            />
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span>
                  {user?.first_name} {user?.last_name}
                </span>
              </a>

              <ul className="dropdown-menu">
                <li
                  className="dropdown-ui-menu"
                  onClick={() => handleProfileClick()}
                >
                  <p className="dropdown-item">Profile</p>
                </li>
                <li
                  onClick={() => handleChangePasswordClick()}
                  className="dropdown-ui-menu"
                >
                  <p className="dropdown-item">Change Password</p>
                </li>
                <li className="dropdown-ui-menu">
                  <hr className="dropdown-divider" />
                </li>
                <li className="dropdown-ui-menu">
                  <p
                    onClick={() => handleLogout()}
                    style={{ cursor: "pointer" }}
                    className="dropdown-item"
                  >
                    Logout
                  </p>
                </li>
              </ul>
            </li>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
